import payoutType from './revenueWalletTypes'

const initialState = {
  isLoading: false,
  searching: false,
  filtering: false,
  downloading: false,
  search: [],
  myReferrals: {},
  allRevenueWallet: {},
};

export default function revenueWalletReducer(state = initialState, action) {
  switch (action.type) {
    case payoutType.LOADING_REVENUE_WALLET:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case payoutType.GET_MY_REVENUE_PAYOUT:
      return {
        ...state,
        myReferrals: action.payLoad?.data,
      };

    case payoutType.ALL_REVENUE_PAYOUT:
      return {
        ...state,
        allReferrals: action.payLoad?.data,
      };

    case payoutType.SEARCHING:
      return {
        ...state,
        searching: action.payLoad,
      };

    case payoutType.SEARCH_REVENUE_PAYOUT:
      return {
        ...state,
        search: action.payLoad,
      };

    case payoutType.FILTERING_REVENUE_WALLET:
      return {
        ...state,
        filtering: action.payLoad,
      };

    case payoutType.FILTER_REVENUE_WALLET:
      return {
        ...state,
        allRevenueWallet: action.payLoad?.data,
      };

    case payoutType.DOWNLOADING:
      return {
        ...state,
        downloading: action.payLoad,
      };

    default:
      return state;
  }
}
